import React from 'react';
import { motion, useTransform, useViewportScroll } from 'framer-motion';
import { Box, Flex } from '@chakra-ui/react';

const MotionFlex = motion(Flex);

export const SkillSvg = () => {
  const { scrollY } = useViewportScroll();

  const scale = useTransform(scrollY, [0, 400], [1, 2]);

  const opacity = useTransform(scrollY, [0, 400], [1, -0.2]);

  return (
    <MotionFlex
      className="skills"
      width={{ base: 48, md: 64 }}
      height="auto"
      justifyContent="center"
      alignItems="center"
      position="relative"
      style={{
        scale,
        opacity,
      }}
    >
      <motion.div
        style={{
          overflow: 'visible',
          height: '101%',
        }}
      >
        <motion.svg
          xmlns="http://www.w3.org/2000/svg"
          width="100%"
          height="101%"
          viewBox="0 0 470 470"
        >
          <g
            stroke="currentColor"
            fill="none"
            strokeWidth={5}
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <motion.path
              initial={{
                pathLength: 0,
              }}
              animate={{
                pathLength: 1,
                transition: {
                  duration: 4,
                },
              }}
              d="M384.772,235c8.882-8.511,16.981-17.055,24.162-25.541c31.691-37.449,42.197-70.107,29.581-91.959
		c-9.807-16.986-32.157-25.228-64.609-23.839c-18.816,0.806-40.499,4.776-64.019,11.638c-2.93-11.949-6.28-23.237-10.039-33.701
		C283.262,25.427,260.231,0,235,0c-16.83,0-32.947,11.403-46.607,32.978c-11.312,17.864-21.019,42.757-28.26,72.321
		c-11.818-3.439-23.274-6.183-34.22-8.16C77.637,88.417,44.1,95.648,31.484,117.5c-12.616,21.852-2.11,54.51,29.581,91.959
		c7.181,8.486,15.28,17.03,24.162,25.541c-8.882,8.511-16.981,17.055-24.162,25.541C29.374,297.99,18.868,330.648,31.484,352.5
		c8.415,14.575,26.349,22.831,51.863,23.875c1.874,0.077,3.786,0.115,5.741,0.115c20.088,0,44.388-4.045,71.021-11.801
		c2.93,11.955,6.282,23.247,10.042,33.714C186.738,444.573,209.769,470,235,470s48.262-25.427,64.849-71.598
		c3.759-10.464,7.109-21.751,10.039-33.701c23.52,6.861,45.203,10.832,64.019,11.637c2.353,0.101,4.646,0.151,6.89,0.151
		c28.738-0.001,48.624-8.235,57.72-23.99c12.616-21.852,2.11-54.51-29.581-91.959C401.753,252.055,393.654,243.511,384.772,235z
		 M425.525,125c9.081,15.729-1.14,42.981-28.041,74.77c-7.033,8.311-14.991,16.688-23.745,25.038
		c-15.374-13.708-32.697-27.232-51.491-40.181c-1.815-22.73-4.861-44.476-9.04-64.628C369.907,103.406,413.801,104.694,425.525,125z
		 M235.007,319.08c-12.409-6.083-24.88-12.729-37.122-19.796c-12.36-7.136-24.296-14.58-35.708-22.239
		c-0.926-13.713-1.405-27.772-1.405-42.045c0-14.263,0.493-28.301,1.428-42.061c11.406-7.653,23.333-15.091,35.685-22.223
		c12.25-7.072,24.724-13.719,37.128-19.799c12.335,6.053,24.745,12.665,37.101,19.799c12.36,7.136,24.296,14.58,35.708,22.239
		c0.926,13.713,1.405,27.772,1.405,42.045s-0.479,28.331-1.405,42.045c-11.413,7.658-23.348,15.102-35.708,22.239
		C259.774,306.408,247.381,313.014,235.007,319.08z M146.527,266.172c-14.113-10.159-27.254-20.613-39.176-31.172
		c11.928-10.563,25.074-21.021,39.194-31.185c-0.498,10.271-0.773,20.667-0.773,31.185
		C145.772,245.514,146.031,255.919,146.527,266.172z M323.473,203.828c14.113,10.159,27.254,20.613,39.176,31.172
		c-11.922,10.559-25.063,21.012-39.176,31.172c0.496-10.252,0.755-20.658,0.755-31.172S323.969,214.081,323.473,203.828z M235,15
		c18.161,0,36.652,22.478,50.731,61.669c3.682,10.25,6.959,21.337,9.815,33.1c-9.084,3.006-18.392,6.4-27.885,10.195
		c-3.846,1.538-5.718,5.902-4.18,9.748c1.538,3.847,5.901,5.718,9.748,4.18c8.724-3.488,17.275-6.616,25.604-9.391
		c3.178,15.591,5.658,32.181,7.397,49.465c-8.63-5.556-17.512-10.982-26.617-16.239c-35.489-20.49-71.519-36.863-105.136-47.968
		C188.506,51.957,211.965,15,235,15z M72.516,199.77C45.614,167.981,35.394,140.729,44.475,125
		c9.08-15.728,37.791-20.505,78.772-13.101c28.689,5.182,61.089,15.837,94.517,30.897c-9.172,4.718-18.336,9.71-27.378,14.93
		c-9.091,5.249-17.96,10.667-26.578,16.214c0.975-9.612,2.16-19.073,3.602-28.32c0.639-4.093-2.161-7.928-6.254-8.566
		c-4.085-0.64-7.928,2.161-8.566,6.254c-2.09,13.395-3.681,27.2-4.813,41.301c-18.804,12.954-36.136,26.484-51.517,40.198
		C87.507,216.457,79.548,208.08,72.516,199.77z M44.475,345c-9.081-15.729,1.14-42.981,28.041-74.77
		c7.033-8.311,14.991-16.688,23.745-25.038c15.374,13.708,32.697,27.232,51.491,40.181c1.816,22.741,4.864,44.497,9.046,64.658
		C99.728,366.781,55.993,364.949,44.475,345z M285.731,393.331C271.652,432.522,253.161,455,235,455s-36.652-22.478-50.731-61.669
		c-9.856-27.435-16.828-60.82-20.5-97.297c8.63,5.556,17.512,10.982,26.617,16.239c9.032,5.215,18.19,10.204,27.359,14.921
		c-8.821,3.967-17.615,7.652-26.355,11.03c-3.863,1.494-5.785,5.836-4.291,9.7c1.149,2.975,3.988,4.798,6.997,4.798
		c0.898,0,1.813-0.163,2.702-0.506c27.376-10.582,55.239-24.02,82.816-39.942c9.105-5.257,17.987-10.683,26.617-16.239
		c-1.74,17.284-4.219,33.875-7.397,49.465c-8.328-2.774-16.879-5.903-25.603-9.39c-3.845-1.538-8.21,0.333-9.748,4.18
		s0.334,8.21,4.18,9.748c9.492,3.795,18.8,7.189,27.884,10.195C292.69,371.994,289.414,383.081,285.731,393.331z M425.525,345
		c-11.723,20.305-55.616,21.594-112.317,5.001c4.179-20.153,7.225-41.898,9.04-64.628c18.794-12.949,36.118-26.472,51.491-40.181
		c8.753,8.351,16.712,16.728,23.745,25.038C424.386,302.019,434.606,329.271,425.525,345z"
            />
            <motion.path
              initial={{
                opacity: 0,
              }}
              animate={{
                opacity: 1,
                transition: {
                  duration: 3,
                },
              }}
              stroke="#DD6B20"
              d="M235,188c-25.916,0-47,21.084-47,47s21.084,47,47,47s47-21.084,47-47S260.916,188,235,188z M235,267
		c-17.645,0-32-14.355-32-32s14.355-32,32-32s32,14.355,32,32S252.645,267,235,267z"
            />
          </g>
        </motion.svg>
      </motion.div>
    </MotionFlex>
  );
};
